// Mock data for Citiwide Construction Services

export const companyInfo = {
  name: "Citiwide Construction Services",
  tagline: "Building Excellence Since 1984",
  owner: "Curtis M. Dilworth III",
  experience: "40+",
  completedProjects: "105+",
  mission: "To deliver high-quality construction services that meet and exceed our clients' expectations.",
  overview: "A comprehensive design-build firm with more than 40 years of expertise. Specializing in the hospitality market since 1995, our experience spans both public and private sectors. We are committed to high standards of safety, quality, and efficiency.",
  phone: "(770) 767-2929",
  email: "info@citiwideatlanta.com",
  address: "1055 Howell Mill Rd #8082, Atlanta GA 30318"
};

export const services = [
  {
    id: 1,
    title: "Site Survey",
    description: "Surveying existing buildings and sites, verifying dimensions, and locating critical structures for accurate project planning.",
    icon: "Compass"
  },
  {
    id: 2,
    title: "Architectural Design",
    description: "Providing complete project design from conceptual designs to construction-ready drawings tailored to your vision.",
    icon: "PenTool"
  },
  {
    id: 3,
    title: "Permitting & Approvals",
    description: "Managing the entire permitting and approval phase, ensuring compliance with all local regulations.",
    icon: "FileCheck"
  },
  {
    id: 4,
    title: "Construction Management",
    description: "Scheduling and conducting meetings to review plans, specifications, schedules, and material delivery.",
    icon: "Building2"
  },
  {
    id: 5,
    title: "Project Oversight",
    description: "Monitoring contractor performance, maintaining schedules, and overseeing material and equipment ordering.",
    icon: "Eye"
  },
  {
    id: 6,
    title: "Inspection & Approval",
    description: "Inspecting completed installations for standards compliance and ensuring punch list completion.",
    icon: "ClipboardCheck"
  }
];

export const projects = [
  {
    id: 1,
    name: "Monticello Bistro & Sports Bar",
    category: "Hospitality",
    size: "17,000 SF",
    description: "Sports Bar, Cigar Lounge & Live Entertainment Venue",
    image: "https://customer-assets.emergentagent.com/job_brick-by-brick-4/artifacts/vhzi1vsy_logo-monticello.jpg"
  },
  {
    id: 2,
    name: "The Bermuda Bar",
    category: "Hospitality",
    size: "18,000 SF",
    description: "Live Entertainment Venue & Cigar Lounge",
    image: "https://customer-assets.emergentagent.com/job_brick-by-brick-4/artifacts/uq7dwitv_Bermuda%20Bar.JPG"
  },
  {
    id: 3,
    name: "Echelon 3000 Ultra Bistro",
    category: "Hospitality",
    size: "15,000 SF",
    description: "Jazz Restaurant with 3000 SF Skybox",
    image: "https://customer-assets.emergentagent.com/job_brick-by-brick-4/artifacts/1v8167ap_e3k.jpg"
  },
  {
    id: 4,
    name: "Sweet Auburn Seafood",
    category: "Hospitality",
    size: "8,000 SF",
    description: "Upscale Seafood Restaurant",
    image: "https://customer-assets.emergentagent.com/job_brick-by-brick-4/artifacts/27i4r72m_sweet%20aub%20sfood.jpg"
  },
  {
    id: 5,
    name: "Hartsfield-Jackson Atlanta International Airport",
    category: "Commercial",
    size: "Large Scale",
    description: "Moving Sidewalk Corridors & Immigration Intake Offices",
    image: "https://customer-assets.emergentagent.com/job_brick-by-brick-4/artifacts/y0ytwu7x_Atl%20airport.jpg"
  },
  {
    id: 6,
    name: "Morehouse College",
    category: "Commercial",
    size: "Full Building",
    description: "Complete Dormitory Renovation",
    image: "https://customer-assets.emergentagent.com/job_brick-by-brick-4/artifacts/q16jwt8w_Morehouse-College-Seal-Logo.png"
  },
  {
    id: 7,
    name: "City of Atlanta",
    category: "Commercial",
    size: "Multiple Locations",
    description: "Municipal Construction Projects",
    image: "https://customer-assets.emergentagent.com/job_brick-by-brick-4/artifacts/rir5cvah_atlanta_logo.jpg"
  },
  {
    id: 8,
    name: "Atlanta Housing Authority",
    category: "Residential",
    size: "50+ Units",
    description: "Fast Track Renovation Project",
    image: "https://customer-assets.emergentagent.com/job_brick-by-brick-4/artifacts/sojfvtwu_aha-logo.gif"
  },
  {
    id: 9,
    name: "Chef Rob's Caribbean Cafe & Bar",
    category: "Hospitality",
    size: "Multiple Buildouts",
    description: "Original Build-out, Lounge Addition & Renovation",
    image: "https://customer-assets.emergentagent.com/job_brick-by-brick-4/artifacts/dz1dgewc_chef%20rob.png"
  },
  {
    id: 10,
    name: "El Noa Noa",
    category: "Hospitality",
    size: "Entertainment Venue",
    description: "Latin Entertainment & Nightclub Venue",
    image: "https://customer-assets.emergentagent.com/job_brick-by-brick-4/artifacts/y81pub4z_el%20noa%20noa.jpg"
  },
  {
    id: 11,
    name: "Grady Hospital",
    category: "Commercial",
    size: "Healthcare Facility",
    description: "Specialty Flooring Installation",
    image: "https://customer-assets.emergentagent.com/job_brick-by-brick-4/artifacts/h42adz54_grady%20logo.jpg"
  },
  {
    id: 12,
    name: "Fulton County",
    category: "Commercial",
    size: "Government Facility",
    description: "County Government Construction Projects",
    image: "https://customer-assets.emergentagent.com/job_brick-by-brick-4/artifacts/2qpmvi8s_Fulton%20Co.jpg"
  },
  {
    id: 13,
    name: "Guilford Forest",
    category: "Residential",
    size: "32 Lots",
    description: "Subdivision Development & 5 Custom Built Homes",
    image: "https://customer-assets.emergentagent.com/job_brick-by-brick-4/artifacts/6s8c89uj_guilford-01.jpg"
  },
  {
    id: 14,
    name: "Housing Authority of Fulton County",
    category: "Residential",
    size: "Multiple Units",
    description: "Affordable Housing Construction & Renovation",
    image: "https://customer-assets.emergentagent.com/job_brick-by-brick-4/artifacts/nfvtmcgd_housing-authority-of-fulton-county_orig.jpg"
  },
  {
    id: 15,
    name: "Smoothie King",
    category: "Hospitality",
    size: "Franchise Location",
    description: "Franchise Juice Bar Build-out",
    image: "https://customer-assets.emergentagent.com/job_brick-by-brick-4/artifacts/py6cupss_SKinglogo-02.jpg"
  },
  {
    id: 16,
    name: "Taboo 2 Bistro & Bar",
    category: "Hospitality",
    size: "9,000 SF",
    description: "Jazz Club & Entertainment Venue",
    image: "https://customer-assets.emergentagent.com/job_brick-by-brick-4/artifacts/jspw3pye_taboo_logo.jpg"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "T.D.",
    role: "Restaurant Owner",
    company: "The Pearl Bistro",
    quote: "Citiwide transformed our vision into reality. Their attention to detail and understanding of hospitality design is unmatched. The space they created has become the heart of Atlanta's jazz scene.",
    rating: 5
  },
  {
    id: 2,
    name: "S.W.",
    role: "Property Developer",
    company: "East Lake Developments",
    quote: "Working with Curtis and his team was exceptional. They delivered our residential project on time and the quality exceeded our expectations. True professionals in every sense.",
    rating: 5
  },
  {
    id: 3,
    name: "A.B.",
    role: "Facilities Director",
    company: "Morehouse College",
    quote: "The dormitory renovation was completed seamlessly with minimal disruption to campus life. Citiwide's project management expertise made all the difference.",
    rating: 5
  }
];

export const stats = [
  { label: "Years Experience", value: "40+" },
  { label: "Residential Projects", value: "200+" },
  { label: "Hospitality Venues", value: "105" },
  { label: "Client Satisfaction", value: "100%" }
];

export const ownerEducation = [
  { year: "1982 – 1986", institution: "Auburn University, Auburn, Alabama", degree: "Bachelor of Science, Business Economics" },
  { year: "1987", institution: "Georgia Institute of Home Builders", degree: "Professional Certification" },
  { year: "1988", institution: "Trans-Con Construction Management", degree: "Management Training" }
];
